import React from 'react';
import { connect } from 'react-redux/dist/react-redux.min.js';

import { Grid, InputAdornment, TextField, Checkbox } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Autocomplete from '@material-ui/lab/Autocomplete';

import debounce from 'lodash.debounce';
import ReduxStore from '../redux/reduxStore.jsx';
const SharedConstants = require('../../../../shared/sharedConstants');

class MPubSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchString: '',
            advSearch: [],
        };
    }

    componentDidMount() {
       if(this.props.initialAdvSearch){
          this.setSearch('advSearch', this.props.initialAdvSearch)
       }
    }

   setSearch(type, value) {
        this.setState({ [type]: value }, () => {
           let cardTypes = this.state.advSearch
              .filter(x => x.group === "Card Type")
              .map(x => x.name === 'Evidence' ? SharedConstants.CardType.Evidence : SharedConstants.CardType.Reasoning)
           let topicArray = this.state.advSearch
              .filter(x => !x.group)
              .map(x => x.idTopic);
           this.props.setFilterOptions(cardTypes, this.state.searchString, topicArray);
           if (!this.debouncedSearch) {
              this.debouncedSearch = debounce(this.props.search, 500);
           }
           this.debouncedSearch();
        });
    }

    render() {
        const { options } = this.props;
        return (
            <Grid container spacing={2}>
               <Grid style={{ alignSelf: 'start' }} item sm={9} md={9} lg={9}>
                  <TextField
                     fullWidth
                     variant="outlined"
                     style={{ backgroundColor: '#EDEFFA' }}
                     placeholder="Search Polyplexus"
                     color="primary"
                     onChange={event => this.setSearch('searchString', event.target.value)}
                     InputProps={{
                        startAdornment: (
                           <InputAdornment position="start">
                              <FontAwesomeIcon size={'2x'} icon={['fas', "file-search"]} color="#4457CF" transform="shrink-5" />
                           </InputAdornment>
                        ),
                     }}
                  />
               </Grid>
               <Grid item sm={3} md={3} lg={3}>
                  <Autocomplete
                     fullWidth
                     multiple
                     disableCloseOnSelect
                     id='advanced-search'
                     options={options}
                     getOptionSelected={(option, value) => option.name === value.name}
                     getOptionLabel={option => option.name}
                     groupBy={option => option.group || 'Topics'}
                     onChange={(event, value) => this.setSearch('advSearch', value)}
                     renderOption={(option, state) => (
                        <>
                           {option.group == 'Card Type' && (
                              <div style={{ marginTop: -7, marginBottom: -7 }}>
                                 <Checkbox
                                    style={{ marginLeft: -10 }}
                                    color='primary'
                                    checked={state.selected}
                                 />
                              </div>
                           )}
                           {option.name}
                        </>
                     )}
                     renderInput={params => (
                        <TextField
                           {...params}
                           variant="outlined"
                           style={{ backgroundColor: '#EDEFFA' }}
                           placeholder="Advanced Search"
                           color="primary"
                        />
                     )}
                  />
               </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    options: [
       {group: 'Card Type', name: 'Evidence'},
       {group: 'Card Type', name: 'Conjecture'},
       ...state.EditorReducer.allTopics
    ],
});

const mapDistpatchToProps = (dispatch) => {
   return {
      setFilterOptions: (cardTypeArray, searchString, topicArray) => {
         dispatch(ReduxStore.EditorFunctions.setCardTypeFilterArray(cardTypeArray));
         dispatch(ReduxStore.EditorFunctions.setSearchString(searchString));
         dispatch(ReduxStore.EditorFunctions.setTopicFilterArray(topicArray));
      }
   }
};

export default connect(mapStateToProps, mapDistpatchToProps)(MPubSearch);
